import { endpoints } from "@app/api/apis";
import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import axios from "axios";
import { useEffect, useState } from "react";
const RenewBreakUp = ({closeBottomSheet,accountId})=> {
    const [breakUpData,setBreakUpData] = useState({})

    useEffect(()=>{
        const url = endpoints.renewalBreakUp +accountId
        axios.get(url)
        .then((res)=>{
            setBreakUpData(res.data)
        }
        ).catch((err)=>{
            closeBottomSheet()
            console.log('fetchPendingRequests',err)
        }
        )
    },[])
    const {processingCharges,tenure,interestAutoPay,principalRepaymentMode,interestRate} = breakUpData
    return(
        <ThemedView p="lg" backgroundColor="bg-fill-primary">
            <ThemedText variant="b2s" color="text-primary" mb="lg">
                Renewal fee and other details
            </ThemedText>
            <ThemedView p="md" backgroundColor="bg-fill-primary" borderRadius="md" borderWidth={1} borderColor="border-secondary" mb="lg">
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b3r" color="text-secondary">Renewal fee (excl. of GST)</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">₹{formatIndianCurrency(processingCharges)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" width={'100%'}  my="md"/>
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b3r" color="text-secondary">Interest rate</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">{interestRate}%</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" width={'100%'}  my="md"/>
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b3r" color="text-secondary">Tenure</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">{tenure} months</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" width={'100%'}  my="md"/>
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b3r" color="text-secondary">Interest autopay</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">{interestAutoPay}rd of every month</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" width={'100%'}  my="md"/>
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b3r" color="text-secondary">Principal repayment</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">{principalRepaymentMode}</ThemedText>
                </ThemedView>
            </ThemedView>
            <Button label="Ok, got it!" size="MD" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}
export default RenewBreakUp